<template>
    <div class="dealLoginPwd">
        <Header title="登录密码" :show-back="true"/>
        <div class="wrapper">
            <van-field
                    class="cell"
                    v-model="password"
                    label="登录密码"
                    label-class="cell-label"
                    type="password"
                    placeholder="请输入登录密码"/>
            <van-field
                    class="cell"
                    v-model="password1"
                    label="确认密码"
                    label-class="cell-label"
                    type="password"
                    placeholder="请再次输入登录密码"/>
            <button class="form-item-btn" @click="submit">确认</button>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import {mapMutations} from "vuex"

    export default {
        components: {
            Header
        },
        data() {
            return {
                hasDealPsd: false, //是否设置交易密码
                verificationCode: "",
                password: "",
                password1: "",
                codeFlag: false,
            };
        },
        methods: {
            submit() {
                if (!this.password) {
                    this.$toast("请输入交易密码");
                    return;
                }
                if (!this.password1) {
                    this.$toast("请再次输入交易密码");
                    return;
                }
                if (this.password !== this.password1) {
                    this.$toast("两次输入的密码不一致");
                    return;
                }
                let parme = {
                    password: this.password,
                    vertification: this.verificationCode,
                };
                this.ajax.post("appapi/user/editPassword", parme).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.setUserInfo({paypwd: 1});
                        this.$router.go(-1);
                    }
                })
            },
            ...mapMutations(["setUserInfo"])
        }
    };
</script>


<style lang="scss">
    .dealLoginPwd {
        .wrapper {
            padding: 30px;
        }

        .form {
            height: 636px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 12px 34px 0 rgba(48, 77, 120, 0.1);
            border-radius: 20px;
        }

        .cell {
            padding: 60px 40px 25px;

            &-label {
                font-size: 30px;
                color: #333;
                font-weight: bold;
            }

            input {
                font-size: 24px;
                color: #c5c4c4;
            }

            .code-btn {
                font-size: 28px;
                cursor: pointer;
                font-weight: bold;
                color: rgba(31, 194, 109, 1);
                line-height: 20px;
            }
        }

        .form-item-btn {
            margin-top: 50px;
        }
    }
</style>
